var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var BaseTaskPayload = /** @class */ (function () {
    function BaseTaskPayload(calculateProgressUpdated) {
        this.calculateProgressUpdated = calculateProgressUpdated;
    }
    BaseTaskPayload.prototype.getCompletedValueFor = function (completed) {
        return completed ? getNowISOString() : false;
    };
    BaseTaskPayload.prototype.toSetTaskCompleted = function (completed) {
        return {
            completed: completed ? this.getCompletedValueFor(completed) : null,
        };
    };
    BaseTaskPayload.prototype.toUpdateProcedure = function (hashid, payload) {
        var _a;
        var progressPayload = {
            progress: (_a = {}, _a[hashid] = payload, _a),
        };
        return __assign(__assign({}, this.calculateProgressUpdated(progressPayload.progress)), progressPayload);
    };
    BaseTaskPayload.prototype.toSetProcedureCompleted = function (hashid, completed) {
        return this.toUpdateProcedure(hashid, {
            set_completed: this.getCompletedValueFor(completed),
            steps: [],
        });
    };
    BaseTaskPayload.prototype.toSetCompleted = function (completed) {
        return this.toSetTaskCompleted(completed);
    };
    return BaseTaskPayload;
}());
export { BaseTaskPayload };
function getNowISOString() {
    // remove milliseconds to be compatible with moment().utc()
    return new Date().toISOString().replace(/\.\d{3}Z$/, 'Z');
}
